<section class="header">

  <div class="menu">
    <div class="title" (clickOutside)="closeDropdown()" appClickOutside>
      <span class="title-icon" [class]="selectedSub.icon"></span>
      <span class="title-text truncate-ellipsis">{{selectedSub.name}}</span>
    </div>
    <div class="dropdown" [class.collapsed]="!dropdownToggle">
      <div
        *ngFor="let subscription of subscriptions"
        class="menu-item"
        [class.active]="subscription.id === selectedSub.id"
        [class.disabled]="!subscription.entitled"
        (click)="subscriptionClicked(subscription)"
      >
        <span class="item-icon" [class]="subscription.entitled ? subscription.icon : 'icon-locked'"></span>
        <span class="item-title">{{ subscription.name }}</span>
      </div>
    </div>
  </div>

  <div class="tabs">
    <div
      *ngFor="let tab of tabs"
      class="tab"
      [class.active]="tab.id === activeTab"
      (click)="tabClicked(tab.id)"
    >
      <span class="icon" [class]="tab.icon"></span>
      <span class="tab-title truncate-ellipsis">{{ tab.title }}</span>
    </div>
  </div>

</section>
